import { ref, computed } from '@vue/composition-api'
import store from '@/store'
import { UPDATE_SHIPMENT } from '@/store/modules/shipment.module'
import { UPDATE_ORDER } from '@/store/modules/order.module'
import { apiToastError, apiToastSuccess } from '@/@core/utils/toast'

export function useOrderAddresses() {
  const isEditNotes = ref(false)
  const notes = ref('')

  const isBrand = computed(() => store.getters.isBrand)
  const isRetailer = computed(() => store.getters.isRetailer)

  function hasBillingAddress(order) {
    return (
      order?.billingAddressForRetailer?.billingAddressLine1
      && order?.billingAddressForRetailer?.billingContactName
    )
  }

  function hasShippingAddress(order) {
    return (
      order?.shippingAddressForRetailer?.shippingAddressLine1
      && order?.shippingAddressForRetailer?.shippingContactName
    )
  }

  function initNotes(order) {
    notes.value = order?.notes || ''
  }

  function onUpdateNotes(order) {
    const payload = {
      notes: notes.value,
    }
    const updateApi = order.shipmentId
      ? store.dispatch(UPDATE_SHIPMENT, {
          shipmentId: order.shipmentId,
          payload,
        })
      : store.dispatch(UPDATE_ORDER, { orderId: order._id, payload })
    return updateApi
      .then(() => {
        isEditNotes.value = false
        apiToastSuccess('Notes updated successfully')
      })
      .catch(error => {
        apiToastError(error)
      })
  }

  return {
    isEditNotes,
    notes,
    isBrand,
    isRetailer,
    hasBillingAddress,
    hasShippingAddress,
    initNotes,
    onUpdateNotes,
  }
}
